import React from "react";
import Logo from "./logo";
import { useTranslation } from "react-i18next";

function AboutMark({ innerRef }) {
  const { t } = useTranslation();
  const steps = [
    {
      title: t("step1Title"),
      desc: <a href="https://sso.moiat.gov.ae/Account/Login" target="_blank">https://sso.moiat.gov.ae/Account/Login</a>,
    },
    {
      title: t("step2Title"),
      desc: t("step2Desc"),
    },
    {
      title: t("step3Title"),
      desc: t("step3Desc"),
    },
    {
      title: t("step4Title"),
      desc: t("step4Desc"),
    },
    {
      title: t("step5Title"),
      desc: t("step5Desc"),
    }
  ];
  return (
    <section ref={innerRef} id="aboutMark">
      <div className="row featurette">
        <div className="col-md-8">
          <h1>{t("aboutMadeInTheEmiratesMark")}</h1>
          <p className="text-body-secondary">{t("powerfulTool")}</p>
          <p className="lead">
            <b>“{t("madeInTheEmirates")}”</b> {t("markDefinition")}
          </p>
        </div>
        <div className="col-md-4">
          <Logo color="" className="w-100 h-auto" width={600} height={450} />
        </div>
      </div>
      <h1>{t("goals")}</h1>
      <p className="text-body-secondary">{t("madeInTheEmiratesMarkAimsTo")}</p>
      <div className="row text-center mt-5">
        <div className="col-4">
          <div className="icon">1</div>
          <p className="object-title">
            {t("marketEmiratiProductsWithStatementnt")}
            <br />“{t("madeInTheEmirates")}”
          </p>
        </div>
        <div className="col-4">
          <div className="icon">2</div>
          <p className="object-title">
            {t("enhanceQualityOf")}
            <br /> {t("nationalProducts")}
          </p>
        </div>
        <div className="col-4">
          <div className="icon">3</div>
          <p className="object-title">
            {t("opportunityFor")}
            <br /> {t("newMarkets")}
          </p>
        </div>
      </div>

      <hr className="featurette-divider" />

      <div className="row">
        <div className="col-md-10">
          <h1>{t("serviceTitle")}</h1>
          <p className="lead">
            {t("serviceDescription")}
            <a href="https://www.moiat.gov.ae" target="_blank">
              www.moiat.gov.ae
            </a>
          </p>

          <div className="vs-steps">
            {steps.map((s, idx) => (
              <div key={idx}
                className="vs-step active d-flex flex-column"
                aria-current="step"
              >
                <div className="vs-badge">
                  <span>{idx + 1}</span>
                </div>
                <div className="ms-4">
                  <div className="vs-title">{s.title}</div>
                  <p className="vs-desc mb-0">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* <h4>
            <strong> {t("serviceFeesTitle")} </strong>
          </h4>
          <p className="lead">{t("serviceFees")}</p>
          <a
            className="btn btn-success"
            target="_blank"
            href="https://moiat.gov.ae/en/services/issuance-license-of-made-in-the-emirates-mark"
          >
            {t("applyNow")}
          </a> */}
        </div>
        <div className="col-md-2">
          <h6 className="text-center">{t("scantoApply")}</h6>
          <img
            src="/assets/images/service-qr-code.png"
            className="w-100 h-auto qrcode"
            alt="service qr code"
            width={600}
            height={450}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutMark;
